import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react'

export const CapaCampos = ({formState}) => {
    const classes = useStyles();
    
    
  return (
      <div className={classes.capaCampos}>
          {(formState?.title)&&<h1 className={classes.title}>{formState.title}</h1>}
          <pre className={classes.preBox}>
                <Box  className={classes.textodescription}>
                    {formState.description}
                </Box>
          </pre>
          {(formState?.signature)&&<p className={classes.signature}>{formState.signature}</p>}
      </div>
  )
}
const useStyles = makeStyles((theme) => ({
    capaCampos:{
        textAlign: 'left',
        overflow:'hidden',
        position: 'absolute',
        left:'0px',
        top:'0px',
        width:'100%',
        height:'100%',
        padding:'15% 10%',
        boxSizing:'border-box',
        
    },
    preBox:{
        maxWidth:'100%',
        whiteSpace:'break-spaces',
    },
    title:{
        fontSize:'1.2rem',
        [theme.breakpoints.up('xxs')]: {
            fontSize:'0.8rem',
        },
        [theme.breakpoints.up('xs')]: {
            fontSize:'0.9rem',
        },

        [theme.breakpoints.up('sm')]: {
            fontSize:'1rem',
        },
        
        [theme.breakpoints.up('md')]: {
            fontSize:'1rem',
        },

        [theme.breakpoints.up('md')]: {
            fontSize:'1.2rem',
        },
    },
    textodescription:{
        fontSize:'1rem',
        [theme.breakpoints.up('xxs')]: {
            fontSize:'0.4rem',
        },
        [theme.breakpoints.up('xs')]: {
            fontSize:'0.7rem',
        },

        [theme.breakpoints.up('sm')]: {
            fontSize:'0.9rem',
        },
        
        [theme.breakpoints.up('md')]: {
            fontSize:'0.9rem',
        },

        [theme.breakpoints.up('md')]: {
            fontSize:'1rem',
        },
        
    },

    signature:{
        fontFamily:'Fasthand!important',
        textAlign:'right',
        fontSize:'1.2rem',
        [theme.breakpoints.up('xxs')]: {
            fontSize:'0.8rem',
        },
        [theme.breakpoints.up('xs')]: {
            fontSize:'1rem',
        },

        [theme.breakpoints.up('sm')]: {
            fontSize:'1.5rem',
        },
        
        [theme.breakpoints.up('md')]: {
            fontSize:'2rem',
        },

        [theme.breakpoints.up('md')]: {
            fontSize:'1.2rem',
        },
        
    }
}))